import { CascadiaSpacing } from "./spacing";

interface CascadiaLayoutType {
  columns: number;
  alignment: string[];
  maxWidth: (string | number)[];
  gapHorizontal: CascadiaSpacing[];
  gapVertical: CascadiaSpacing[];
  marginHorizontal: CascadiaSpacing[];
  marginVertical: CascadiaSpacing[];
}

export type CascadiaLayout =
  | "auth"
  | "applicant/narrow"
  | "narrow"
  | "wide"
  | "report-tiles"
  | "full-width";

export const layouts: Record<CascadiaLayout, CascadiaLayoutType> = {
  auth: {
    columns: 12,
    alignment: ["fixed-centre"],
    maxWidth: ["100%", 416],
    gapHorizontal: ["space-4"],
    gapVertical: ["space-6"],
    marginHorizontal: ["space-5", "space-6"],
    marginVertical: ["space-10", "space-12"],
  },
  "applicant/narrow": {
    columns: 12,
    alignment: ["fixed-centre"],
    maxWidth: ["100%", 560],
    gapHorizontal: ["space-4"],
    gapVertical: ["space-6"],
    marginHorizontal: ["space-4", "space-6"],
    marginVertical: ["space-10", "space-12"],
  },
  narrow: {
    columns: 12,
    alignment: ["stretch", "stretch"],
    maxWidth: ["100%", 560],
    gapHorizontal: ["space-8"],
    gapVertical: ["space-6", "space-6", "space-8"],
    marginHorizontal: ["space-4", "space-4", "space-8"],
    marginVertical: ["space-7"],
  },
  wide: {
    columns: 12,
    alignment: ["stretch"],
    maxWidth: ["100%", 1200],
    gapHorizontal: ["space-4", "space-4", "space-6"],
    gapVertical: ["space-6", "space-6", "space-8"],
    marginHorizontal: ["space-4", "space-4", "space-8"],
    marginVertical: ["space-5"],
  },
  "full-width": {
    columns: 12,
    alignment: ["stretch"],
    maxWidth: ["100%", "100%", 1440],
    gapHorizontal: ["space-4", "space-4", "space-6"],
    gapVertical: ["space-6", "space-6", "space-8"],
    marginHorizontal: ["space-4", "space-4", "space-8"],
    marginVertical: ["space-5"],
  },
  "report-tiles": {
    columns: 12,
    alignment: ["stretch"],
    maxWidth: ["100%", "100%", 1440],
    gapHorizontal: ["space-2"],
    gapVertical: ["space-2"],
    marginHorizontal: ["space-4", "space-4", "space-8"],
    marginVertical: ["space-5"],
  },
};
